import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, BellOff } from "lucide-react";
import { SubHeader, EmptyState } from "@/components/Brand";
import { api, useApi } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { PushToggle } from "@/components/PushToggle";
import { RevokeButton } from "@/components/RevokeButton";

export default function Notifications() {
  const navigate = useNavigate();
  const { data, reload } = useApi("/notifications");

  useEffect(() => {
    if (data?.some((n) => !n.read)) api.post("/notifications/read-all");
  }, [data]);

  return (
    <div>
      <SubHeader title="Notifikasi" onBack={() => navigate(-1)} />
      <div className="px-5 mb-3"><PushToggle /></div>
      <div className="px-5 space-y-2" data-testid="notifications-list">
        {data?.length === 0 && <EmptyState testid="notifications-empty" icon={BellOff} title="Belum ada notifikasi" />}
        {data?.map((n) => (
          <div key={n.notif_id} className={`flex gap-3 p-4 rounded-2xl border ${n.read ? "bg-white border-slate-200" : "bg-blue-50 border-blue-200"}`}>
            <div className="h-9 w-9 rounded-full bg-red-50 flex items-center justify-center shrink-0"><Bell className="h-4 w-4 text-red-600" /></div>
            <div>
              <div className="font-semibold text-sm text-slate-900">{n.title}</div>
              <div className="text-xs text-slate-600">{n.message}</div>
              <div className="text-[11px] text-slate-400 mt-1">{fmtDateTime(n.created_at)}</div>
              {n.kind === "ticket" && n.ticket_id && (
                <button onClick={() => navigate(`/app/bantuan/${n.ticket_id}`)} data-testid={`notif-ticket-${n.notif_id}`}
                  className="mt-2 inline-flex items-center gap-1 bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-semibold px-3 py-1.5 rounded-lg">Lihat Tiket</button>
              )}
              {n.kind === "new_login" && n.sess_ref && (
                n.revoked
                  ? <div className="mt-2 text-[11px] font-semibold text-emerald-700" data-testid={`notif-revoked-${n.notif_id}`}>Perangkat sudah dikeluarkan</div>
                  : <RevokeButton sessRef={n.sess_ref} testid={`notif-not-me-${n.notif_id}`} onDone={reload} className="mt-2" />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
